import script from "./DocPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./DocPanel.vue?vue&type=script&setup=true&lang=js"

import "./DocPanel.vue?vue&type=style&index=0&id=3a85ce66&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a85ce66"]])

export default __exports__